export const BASE_URL = getBaseUrl()
export const BASE_FRONT_END_URL = getBaseFrontEndUrl()

export const OAUTH2_REDIRECT_URI = window.location.origin + '/oauth2/redirect'

export const LOADER_OVERLAY_BACKGROUND = 'transparent'
export const LOADER_COLOR = '#266EF1'
export const LOADER_WIDTH = '80px'
export const LOADER_TEXT = '' //temporarily removed
export const LOADER_POSITION = 'fixed'
export const LOADER_TOP = '50%'
export const LOADER_LEFT = '50%'
export const LOADER_MARGIN_TOP = -100
export const LOADER_MARGIN_LEFT = 0
export const hjid = getHotjarId()
export const hjsv = 6
export const GA_ID = 'UA-168122648-1'
export const LOCAL_QUOTE_NOW_KEY = 'nitex@quoteNowObj'
export const SURVEYSPARROW_TOKEN =
    'pr_upQBJ3jS1ZomrjHJ4BRNUP3_dCjeJWON2HZaumJk_lp5x3lsuu3UtK7BbT9-nSRZit-_0KaBSlfXGwanBKJ5w'

export const HTTP_STATUS = {
    OK: 200,
    'Bad Request': 400,
    Unauthorized: 401,
    Forbidden: 403,
    'Not Found': 404,
    'Method Not Allowed': 405,
    'Not Acceptable': 406,
    'Request Time-out': 408,
    Conflict: 409,
    Gone: 410,
    'Unsupported Media Type': 415,
    'Expectation Failed': 417,
    'Precondition Required': 428,
    'Valid OTP Exists': 452
}

function getBaseUrl() {
    const hostName = window.location.toString()

    if (hostName.indexOf('https://test.nitex.com') > -1) {
        return 'https://testadmin-copy2.nitex.com/api/core'
        // return 'https://testadmin.nitex.com/api/core'
    } else if (hostName.indexOf('https://app.nitex.com') > -1) {
        return 'https://app.nitex.com/api/core'
    } else if (hostName.indexOf('https://demo.nitex.com') > -1) {
        return 'https://demo.nitex.com/api/core'
    } else if (hostName.indexOf('localhost') > -1) {
        // return 'https://testadmin.nitex.com/api/core'
        // return 'https://test.nitex.com/api/core'
        return 'https://testadmin-copy2.nitex.com/api/core'
        // return 'https://testadmin-copy1.nitex.com/api/core'
        //return 'http://localhost:8443'
    }
}

function getBaseFrontEndUrl() {
    const hostName = window.location.toString()
    if (hostName.indexOf('https://test.nitex.com') > -1) {
        return 'https://test.nitex.com'
    } else if (hostName.indexOf('https://testadmin.nitex.com') > -1) {
        return 'https://testadmin.nitex.com'
    } else if (hostName.indexOf('https://app.nitex.com') > -1) {
        return 'https://app.nitex.com'
    } else if (hostName.indexOf('https://admin.nitex.com') > -1) {
        return 'https://admin.nitex.com'
    } else if (hostName.indexOf('https://admin-beta.nitex.com') > -1) {
        return 'https://admin-beta.nitex.com'
    } else if (hostName.indexOf('https://demo.nitex.com') > -1) {
        return 'https://demo.nitex.com'
    } else {
        return 'http://localhost:3000'
    }
}

function getHotjarId() {
    const hostName = window.location.toString()

    if (hostName.indexOf('https://app.nitex.com') > -1) {
        return 2096288
    } else {
        return 1986852
    }
}

export function getOneSignalAppId() {
    const hostName = window.location.toString()

    if (hostName.indexOf('https://app.nitex.com') > -1) {
        return 'd0288891-96ed-4f96-82f1-698d75dabe49'
    } else {
        return '944586d0-b5c4-4e89-9822-28dd97aaca14'
    }
}

export const isItProductionServer = () => {
    const hostName = window.location.toString()
    if (hostName.indexOf('https://app.nitex.com') > -1) {
        return true
    }
}

export function getBaseWebSocketUrl() {
    const hostName = window.location.toString()
    if (hostName.indexOf('https://test.nitex.com') > -1) {
        return 'wss://test.nitex.com/api/core/ws'
    } else if (hostName.indexOf('https://app.nitex.com') > -1) {
        return 'wss://app.nitex.com/api/core/ws'
    } else if (hostName.indexOf('https://demo.nitex.com') > -1) {
        return 'wss://demo.nitex.com/api/core/ws'
    } else if (hostName.indexOf('localhost') > -1) {
        return 'wss://test.nitex.com/api/core/ws'
    }
}

export const isItLocalServer = () => {
    const hostName = window.location.toString()
    if (hostName.indexOf('http://localhost') !== -1) {
        return true
    }
}
